// src/constants/urls.js
export const URLS = {
    BASE_URL: process.env.REACT_APP_BASEURL,
    IMAGE_URL: process.env.REACT_APP_IMAGEURL,
    THUMBNAIL: process.env.REACT_APP_THMBNAIL,
    EXPLODED_THUMBNAIL: process.env.REACT_APP_THMBNAIL
};